// extracted by mini-css-extract-plugin
export var title = "Title-module--title--k_Rl8";
export var small = "Title-module--small--1GY3v";